import type { SVGProps } from "react";
const SenecPictogramChargeWithApp = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M16 2C13.2386 2 11 4.23858 11 7V33C11 33.5523 11.4477 34 12 34C12.5523 34 13 33.5523 13 33V7C13 5.34315 14.3431 4 16 4H32C33.6569 4 35 5.34315 35 7V41C35 42.6569 33.6569 44 32 44H16C14.3431 44 13 42.6569 13 41V38C13 37.4477 12.5523 37 12 37C11.4477 37 11 37.4477 11 38V41C11 43.7614 13.2386 46 16 46H32C34.7614 46 37 43.7614 37 41V7C37 4.23858 34.7614 2 32 2H16Z"
            fill="currentColor"
        />
        <path
            d="M21 17C20.4477 17 20 17.4477 20 18C20 18.5523 20.4477 19 21 19H27C27.5523 19 28 18.5523 28 18C28 17.4477 27.5523 17 27 17H21Z"
            fill="currentColor"
        />
        <path
            d="M21 31C20.4477 31 20 31.4477 20 32C20 32.5523 20.4477 33 21 33H27C27.5523 33 28 32.5523 28 32C28 31.4477 27.5523 31 27 31H21Z"
            fill="currentColor"
        />
        <path d="M24 21V24H27L24 29V26H21L24 21Z" fill="currentColor" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 9V13H17V37H31V13H28V9H20ZM26 13H22V11H26V13ZM19 35V15H29V35H19Z"
            fill="currentColor"
        />
        <path
            d="M21 39C20.4477 39 20 39.4477 20 40C20 40.5523 20.4477 41 21 41H27C27.5523 41 28 40.5523 28 40C28 39.4477 27.5523 39 27 39H21Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramChargeWithApp;
